'use client';

import { c as _c } from "react/compiler-runtime";
import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';
import type { VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@/lib/utils';
const labelVariants = cva('text-sm font-normal leading-none text-zinc-400 peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
const Label = t0 => {
  const $ = _c(10);
  let className;
  let props;
  let ref;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = cn(labelVariants(), className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
    t2 = <LabelPrimitive.Root ref={ref} className={t1} {...props} />;
    $[6] = props;
    $[7] = ref;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
Label.displayName = LabelPrimitive.Root.displayName;
export { Label };